import axios from 'axios';

const helpers = {
  validate(data) {
    return axios
      .post(`/refinement/validate`, data)
      .then(data => {
        if (data.data.valid) {
          return true;
        } else {
          return false;
        }
      })
      .catch(error => {
        return false;
      });
  },

  createIdea(data) {
    return axios
      .post('/refinement/idea-infos', data)
      .then(data => {
        return data.data.url;
      })
      .catch(error => {
        return null;
      });
  },
};

export default helpers;
